import * as R from "ramda";
import { call, reducer } from "../../helpers/api/meta";
import {
  getCourses,
  getLernerCourses,
  getallAssignCourses,
  getReferenceCourses,
  getCPDCourses,
  getAllCreatedCourses,
} from "../../helpers/api/api";

export const GET_COURSES_DATA = "GET_COURSES_DATA";
export const GET_COURSES_RESET = "GET_COURSES_RESET";

export const callResetGetCourses = (inputs, uri) => {
  const meta = {
    endpoint: (params) => getCourses(params, uri),
    inputs,
    action: GET_COURSES_DATA,
    messages: {
      id: "getCourses",
      failure: "Could not get course detail",
    },
    resetData: true,
  };
  return call(meta);
};

export const callGetCourses = (inputs, uri) => {
  const meta = {
    endpoint: (params) => getCourses(params, uri),
    inputs,
    action: GET_COURSES_DATA,
    messages: {
      id: "getCourses",
      failure: "Could not get course detail",
    },
  };
  return call(meta);
};

export const callGetAllCreatedCourses = (inputs, uri) => {
  const meta = {
    endpoint: (params) => getAllCreatedCourses(params, uri),
    inputs,
    action: GET_COURSES_DATA,
    messages: {
      id: "getCourses",
      failure: "Could not get course detail",
    },
  };
  return call(meta);
};
export const callGetallAssignCourses = (inputs) => {
  const meta = {
    endpoint: (params) => getallAssignCourses(params),
    inputs,
    action: GET_COURSES_DATA,
    messages: {
      id: "getCourses",
      failure: "Could not get course detail",
    },
  };
  return call(meta);
};

export const callGetReferenceCourses = (inputs) => {
  const meta = {
    endpoint: (params) => getReferenceCourses(params),
    inputs,
    action: GET_COURSES_DATA,
    messages: {
      id: "getCourses",
      failure: "Could not get course detail",
    },
  };
  return call(meta);
};

export const callGetCPDCourses = (inputs, uri) => {
  const meta = {
    endpoint: (params) => getCPDCourses(params, uri),
    inputs,
    action: GET_COURSES_DATA,
    messages: {
      id: "getCourses",
      failure: "Could not get course detail",
    },
  };
  return call(meta);
};

export const callGetLearnerCourses = (inputs) => {
  const meta = {
    endpoint: (params) => getLernerCourses(params),
    inputs,
    action: GET_COURSES_DATA,
    messages: {
      id: "getCourses",
      failure: "Could not get course detail",
    },
  };
  return call(meta);
};

const initialState = {
  loading: false,
  results: [],
};

const saveCourses = (state, action) => {
  return R.assoc("results", action, state);
};

const messages = {
  loadFailed: "Could not load courses.",
};

export default reducer(
  initialState,
  GET_COURSES_DATA,
  saveCourses,
  messages.loadFailed
);
